<template>
  <div class="h-full w-full">
    <ColumnHeader
      :title="title"
      @loadMore="loadMore"
      v-show="data.showTitle"
      :showMore="data.showMore"
      class="mb-10px"
    />
    <div :class="getBodyClass()">
      <div class="h-full w-full cursor-pointer" @click="toDetail(videoData)" v-if="videoData.id">
        <div class="h-[calc(100%-34px)] w-full flex">
          <div class="relative m-auto h-full w-4/5">
            <el-image
              class="absolute h-full w-full cursor-pointer"
              :src="`${fileUrl}${videoData.indexImage}`"
              :fit="data.imageFit || 'fill'"
              @click="toDetail(videoData)"
            >
            </el-image>
            <img
              src="../../assets/images/视频播放.png"
              alt=""
              class="absolute m-auto w-30px h-30px object-contain top-1/2 left-1/2"
              style="transform: translateX(-50%) translateY(-50%)"
            />
          </div>
        </div>
        <div
          class="text-14px text-hex-333 mt-10px text-center font-bold truncate"
          :title="videoData.title"
        >
          {{ videoData.title }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ColumnTableApi, ColumApi } from '@wiz-api/workbench'
import { informationPublishMap } from '@/modules/portal-management/js/config'
import addRequestQueue from '@/assets/js/RequestQueue'
import ColumnHeader from './ColumnHeader'

const columnTableApi = new ColumnTableApi()
const columApi = new ColumApi()
const columnVideoType = informationPublishMap.column.columnVideo // 视频栏目

export default {
  name: 'NewsVideo',
  components: { ColumnHeader },
  props: {
    data: {
      type: Object,
      default: null,
    },
    mode: {
      type: String,
      default: 'update',
    },
  },
  computed: {
    fileUrl() {
      const fileServer = Wiz.GetModuleServer('file-management')
      return `${fileServer}/api/file-management/files/public/image/`
    },
    routerBase() {
      if (window.__POWERED_BY_QIANKUN__) {
        return `/${_.get(Wiz, 'globalSettings.globalConfig.routerBase')}`
      }
      return ''
    },
  },
  data() {
    return {
      dataSource: '',
      videoData: {},
      title: '视频',
    }
  },
  methods: {
    getBodyClass() {
      if (this.data.showTitle) {
        return 'h-[calc(100%-48px)]'
      }
      return 'h-full'
    },
    loadMore() {
      if (this.mode !== 'update') {
        window.open(
          `${window.location.origin}${window.location.hash ? '/#' : ''}${
            this.routerBase
          }/portal/homepage?columnId=${this.data.dataSource}`
        )
      }
    },
    toDetail(item) {
      if (this.mode === 'view') {
        if (item.externalLink) {
          window.open(item.externalLink)
        } else {
          window.open(
            `${window.location.origin}${window.location.hash ? '/#' : ''}${
              this.routerBase
            }/portal/ColumnDetail?id=${item.id}&type=${columnVideoType}`
          )
        }
      }
    },
    async getVideoListData() {
      const [err, res] = await addRequestQueue(() => {
        return columnTableApi.getVideoColumnTable(1, 1, {
          columnId: this.data.dataSource,
          isShow: true,
        })
      })
      if (!err) {
        this.videoData = res.items[0] || {}
      }
    },
    async getTitle() {
      if (this.data.title) {
        this.getVideoListData()
        return
      }
      const [err, res] = await columApi.getColumnDetail(this.data.dataSource)
      if (!err) {
        this.title = res.name
        this.getVideoListData()
      }
    },
  },
  watch: {
    data: {
      deep: true,
      immediate: true,
      handler(val) {
        if (!_.isEmpty(val)) {
          if (val.title) this.title = val.title
          if (val.dataSource && val.dataSource !== this.dataSource) {
            this.dataSource = val.dataSource
            this.getTitle()
          }
        }
      },
    },
  },
  mounted() {},
}
</script>

<style lang="scss" scoped></style>
